import React from 'react';

import Trustpilot, { SizeOverride } from '@rover/components/src/Trustpilot';
import useGetLogoData from '@rover/components/src/typography/BrandLink/hooks/useLogo';
import { Flex } from '@rover/kibble/core';

const TrainerSearchFooter = (): JSX.Element => {
  const { Logo } = useGetLogoData();

  return (
    <Flex
      sx={{
        paddingTop: '43px',
        paddingBottom: '11px',
      }}
      flexDirection="column"
      alignItems="center"
    >
      {Logo}
      <Trustpilot
        paddingTop="5x"
        margin="0x"
        paddingBottom="0x"
        sizeOverride={SizeOverride.small}
      />
    </Flex>
  );
};

export default TrainerSearchFooter;
